module.exports = __webpack_public_path__ + "img/1sb-alert-boutique.969cc41.svg";